import httpClient from "@/apis/base/axios-httpclient";
import api from "@/apis/OrganizationUnitAPI";
import Crud from "./crud-base";
import commonFn from "@/commons/commonFunction";
const crud = new Crud("OrganizationUnit", api),
  treeCacheKey = "orgTree";

const state = {
  ...crud.state,
  _config: {
    field: {
      key: "OrganizationUnitID",
      name: "OrganizationUnitName",
      code: "OrganizationUnitCode",
    },
  },
  tree: [],
  withOrgUnitPermission: [],
};
const getters = {
  ...crud.getters,
  tree: function (state) {
    return state.tree;
  },
  managerTree: function (state) {
    let rs = [];
    if (state.tree && state.tree.length > 0) {
      rs = state.tree.filter((p) => {
        return p.IsManagementUnit;
      });
    }
    // console.log(rs);
    return rs;
  },
};
const actions = {
  ...crud.actions,
  /**
   * xóa cache tree
   */
  resetTreeCahe() {
    commonFn.removeLocalStorage(treeCacheKey);
  },
  loadTree: async function (context, payload) {
    //kiểm tra cache có không gọi load
    let cache = window._treeOrg; // commonFn.getLocalStorage(treeCacheKey);
    if (cache) {
      // let data = JSON.parse(cache);
      // context.commit("updateTree", data);
      // return data;
      return cache;
    }

    context.commit("updateLoading", true);

    let url = [api.getAPIUrl(), "tree"];
    if (payload == true) {
      url.push(true);
    }

    let request = {
      url: url.join("/"),
    };

    let res = await httpClient.getAsync(request);
    context.commit("updateLoading", false);

    if (res) {
      // commonFn.setLocalStorage(treeCacheKey, JSON.stringify(res));
      window._treeOrg = res;
      context.commit("updateTree", res);
      return res;
    }
  },

  /*
   * pvduy 11/03/2021: hàm lấy dữ liệu từ amis vê
   */
  syncOrganizationUnitFromAMIS: async function () {
    let request = {
      url: [api.getAPIUrl(), "sync_organization_unit"].join("/"),
    };
    return await httpClient.getAsync(request);
  },
};
const mutations = {
  ...crud.mutations,
  updateTree(state, res) {
    state.tree.removeAll();
    state.tree.append(res);
  },
};

export default {
  debug: import.meta.env.PROD,
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
